<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const isBrandingEnabled = computed(() => {
  const brandingDetails = store?.getters?.getBrandingDetails;
  return Boolean(brandingDetails?.primary_color);
});
</script>
<template>
  <div
    class="flex flex-col py-4 px-6"
    :class="isBrandingEnabled ? 'bg-gray-275' : 'bg-teal-light'"
  >
    <slot name="title" />
    <slot name="content" />
  </div>
</template>
